import type { FunctionComponent } from 'react';
import CTAButton, { CTAColorVariant } from '~/components/shared/CTAButton';
import LinkWrapper from '~/components/shared/LinkWrapper/linkWrapper';
import WmplusLogo from '~/components/shared/svg/WmplusLogo';
import {
  headerClasses,
  logoWrapperClasses,
  headerLinksWrapperClasses,
  signInWrapperClasses,
  signInButtonWrapperClasses,
  desktopTextClasses,
  signInButtonImageWrapperClasses,
  ctaClasses,
} from './slimmedNavbarClasses';
import { useMonarchSlotContext } from '@redventures/cohesion-utils-react';
import Image from 'next-export-optimize-images/image';

export interface SlimmedNavbarProps {
  CTAButtonText?: string;
  CTAButtonVariant?: CTAColorVariant;
  CTAButtonLink?: string;
  signInButton?: boolean;
}

const DEFAULT_PROPS = {
  CTAButtonText: 'Claim your free trial',
  CTAButtonVariant: 'secondary' as CTAColorVariant,
  CTAButtonLink: 'https://www.walmart.com/plus/plans',
  signInButton: false,
};

const SlimmedNavbar: FunctionComponent<SlimmedNavbarProps> = (props) => {
  const { data } = useMonarchSlotContext<typeof DEFAULT_PROPS>();
  const finalProps = data ?? props ?? DEFAULT_PROPS;
  const {
    CTAButtonText,
    CTAButtonVariant = 'secondary',
    CTAButtonLink,
    signInButton,
  } = finalProps;

  const imgPath = `${process.env.baseUrl}/images/sections/hero/`;

  return (
    <header className={headerClasses}>
      <LinkWrapper
        href='https://walmart.com'
        className={logoWrapperClasses}
        segmentTracking={{
          elementName: 'WALMART_LOGO',
          elementPosition: 'NAV',
        }}
      >
        <WmplusLogo

          alt='Walmart+ Logo'
          width={94}
          height={32}
        />
      </LinkWrapper>
      <div className={headerLinksWrapperClasses}>
        <div>
          <CTAButton
            className={ctaClasses}
            variant={CTAButtonVariant}
            size='thin'
            elementPosition='NAVBAR'
            elementType='SIGN_UP_CTA_PRIMARY'
            href={CTAButtonLink}
          >
            {CTAButtonText}
          </CTAButton>
        </div>
        {signInButton && (
          <div className={signInWrapperClasses}>
            <LinkWrapper
              href='https://www.walmart.com/plus/plans'
              className={signInButtonImageWrapperClasses}
              segmentTracking={{
                elementName: 'SIGN_IN_BUTTON',
                elementPosition: 'NAV',
              }}
            >
              <Image
                src={`${imgPath}person-white.svg`}
                alt='white person logo'

                width={16}
                height={18}
              />
            </LinkWrapper>
            <div className={signInButtonWrapperClasses}>
              <LinkWrapper
                href='https://www.walmart.com/plus/plans'
                className={desktopTextClasses}
                segmentTracking={{
                  elementName: 'SIGN_IN_BUTTON',
                  elementPosition: 'NAV',
                }}
              >
                Sign In
              </LinkWrapper>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default SlimmedNavbar;
